import { Button, MenuItem, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import styles from './PropertySpyCreateForm.module.css'
import { useCreateMonitorMutation, useReadMonitorCurrentlaunchStatusQuery } from 'services/monitor'
import { useEffect, useState } from 'react'
import { SortOrder } from 'shared/enums'
import { useReadHostServiceListByMonitorIdQuery } from 'services/hostService'
import { ReadHostServiceListByMonitorIdParamsModel } from 'services/hostService/qhostService'
import { HostServiceList } from './presentationals/HostServiceList'
import { SelectPropertySpyListFromMarketSpy } from './containers/SelectPropertySpyListFromMarketSpy'
import { SelectPropertySpyListFromLocation } from './containers/SelectPropertySpyListFromLocation'
import TravelExploreIcon from '@mui/icons-material/TravelExplore'
import { createLocationListSearchMonitor } from 'domain/monitor'
import { HostServicesLoadingProgressDialog } from './presentationals/HostServicesLoadingProgressDialog'
import { SearchingResultDialog } from './presentationals/SearchingResultDialog'

export const PropertySpyCreateForm = (): JSX.Element => {
    const [marketSpyId, setMarketSpyId] = useState<number | undefined>(undefined)
    const [manuallyCloseDialog, setManuallyCloseDialog] = useState<boolean>(false)
    const [locationListMarketSpyId, setLocationListMarketSpyId] = useState<number | undefined>(undefined)
    const [locationListMarketSpyHasRunning, setLocationListMarketSpyHasRunning] = useState<boolean>(false)
    const [hostServicesLoadingProgressDialogOpen, setHostServicesLoadingProgressDialogOpen] = useState<boolean>(false)
    const [searchingResultDialogOpen, setSearchingResultDialogOpen] = useState<boolean>(false)
    const [marketSpyIdForSearchingHostServiceList, setMarketSpyIdForSearchingHostServiceList] = useState<number | undefined>(undefined)
    const [locationList, setLocationList] = useState<string[]>([])
    const [searchMode, setSearchMode] = useState<'marketSpy' | 'locationList'>(`marketSpy`)
    const [sortOrder, setSortOrder] = useState<SortOrder | undefined>(SortOrder.Ascending)
    const [sortField, setSortField] = useState<string>('')
    const [createMonitor] = useCreateMonitorMutation()
    const theme = useTheme()

    const [readMonitorCurrentlaunchStatusQueryParams, setReadMonitorCurrentlaunchStatusQueryParams] = useState<any>(undefined);
    const [readMonitorCurrentlaunchStatusQueryOptions, setReadMonitorCurrentlaunchStatusQueryOptions] = useState<any>(
        {
            skip: true,
            refetchOnMountOrArgChange: true,
            pollingInterval: 500,
        }
    );
    const {
        data: readMonitorCurrentlaunchStatusQueryData,
        isLoading: readMonitorCurrentlaunchStatusQueryIsLoading,
        isFetching: readMonitorCurrentlaunchStatusQueryIsFetching
    } = useReadMonitorCurrentlaunchStatusQuery(readMonitorCurrentlaunchStatusQueryParams, readMonitorCurrentlaunchStatusQueryOptions);

    useEffect(() => {
        setReadMonitorCurrentlaunchStatusQueryParams((prevValue: any) => {
            return {
                ...prevValue,
                monitorId: locationListMarketSpyId
            }
        });

        setReadMonitorCurrentlaunchStatusQueryOptions((prevValue: any) => {
            return {
                ...prevValue,
                skip: locationListMarketSpyId === undefined,
            };
        }) 

        setLocationListMarketSpyHasRunning(() => {
            return locationListMarketSpyId !== undefined
        })
    }, [
        locationListMarketSpyId
    ])

    useEffect(() => {
        if (readMonitorCurrentlaunchStatusQueryData?.status === 1 || readMonitorCurrentlaunchStatusQueryData?.status === 0) {
            setLocationListMarketSpyHasRunning(true)
        }
    }, [
        readMonitorCurrentlaunchStatusQueryData
    ])


    useEffect(() => {
        if (locationListMarketSpyHasRunning === true && readMonitorCurrentlaunchStatusQueryData?.status === 2) {
            setMarketSpyIdForSearchingHostServiceList(locationListMarketSpyId)
            setLocationListMarketSpyId(undefined)
            setLocationListMarketSpyHasRunning(false)
        }
    }, [
        readMonitorCurrentlaunchStatusQueryData,
        locationListMarketSpyHasRunning,
        locationListMarketSpyId
    ])

    const handleOrderChange = (event: any) => {
        console.log('handleOrderChange')
    }
    const handleSortFieldChange = (event: any) => {
        console.log('handleSortFieldChange')
    }

    const renderOrderItems = () => {
        const menuItems: any = [];

        for (const key in SortOrder) {
            if (isNaN(Number(key))) {
                continue;
            }

            menuItems.push(<MenuItem key="key" value={key}>{SortOrder[key]}</MenuItem>)
        }

        return menuItems;
    }

    const [readHostServiceListByMonitorIdQueryParams, setReadHostServiceListByMonitorIdQueryParams] = useState<ReadHostServiceListByMonitorIdParamsModel>({
        monitorId: -1,
    })

    const [readHostServiceListByMonitorIdQueryOptions, setReadHostServiceListByMonitorIdQueryOptions] = useState<any>({
        skip: marketSpyIdForSearchingHostServiceList === undefined || '',
        refetchOnMountOrArgChange: true
    })

    useEffect(() => {
        setManuallyCloseDialog(false)

        setReadHostServiceListByMonitorIdQueryParams((prevValue: any) => {
            return {
                ...prevValue,
                monitorId: marketSpyIdForSearchingHostServiceList
            }
        });

        setReadHostServiceListByMonitorIdQueryOptions((prevValue: any) => {
            return {
                ...prevValue,
                skip: marketSpyIdForSearchingHostServiceList === undefined,
            }
        })
    }, [
        marketSpyIdForSearchingHostServiceList
    ])

    const {
        data: readHostServiceListByMonitorIdQueryData,
        isLoading: readHostServiceListByMonitorIdQueryIsLoading,
        isFetching: readHostServiceListByMonitorIdQueryIsFetching
    } = useReadHostServiceListByMonitorIdQuery(readHostServiceListByMonitorIdQueryParams, readHostServiceListByMonitorIdQueryOptions)

    const getHostServicesForLocationList = async () => {
        const monitor = createLocationListSearchMonitor()

        const result = await createMonitor({
            monitor: {
                ...monitor,
                ...{
                    locations: locationList
                }
            }
        })

        setLocationListMarketSpyId(result?.data?.id)  
        //
    }

    const getHostServicesForMarketSpy = async (marketSpyId: number | undefined) => {
        if (marketSpyId === undefined) {
            return
        }

        setMarketSpyIdForSearchingHostServiceList(marketSpyId)
        setLocationListMarketSpyId(undefined)
        setLocationListMarketSpyHasRunning(false)
    }

    const handleSearchClick = async () => {
        if (searchMode === 'locationList') {
            await getHostServicesForLocationList()

            return
        }

        if (searchMode === 'marketSpy') {
            await getHostServicesForMarketSpy(marketSpyId)

            return
        }
    }

    const handleLocationListChange = (event: any) => {
        setSearchMode('locationList')
        setLocationList(event)
    }

    const handleMarketSpyIdChange = async (event: any) => {
        setSearchMode('marketSpy')
        setMarketSpyId(event)
        await getHostServicesForMarketSpy(event)
    }

    const handleHostServicesLoadingProgressDialogOpenChange = (value: any) => {
        setHostServicesLoadingProgressDialogOpen(value)
        setManuallyCloseDialog(true)
    }

    const handleSearchingResultDialogOpenChange = (value: any) => {
        setSearchingResultDialogOpen(value)
    }

    useEffect(() => {
        if (manuallyCloseDialog === true) {
            setHostServicesLoadingProgressDialogOpen(false)

            return
        }

        if (locationListMarketSpyHasRunning === true) {
            setHostServicesLoadingProgressDialogOpen(true)

            return
        }

        if (readHostServiceListByMonitorIdQueryIsFetching === true) {
            setHostServicesLoadingProgressDialogOpen(true)

            return
        }

        if (readMonitorCurrentlaunchStatusQueryIsFetching === true) {
            setHostServicesLoadingProgressDialogOpen(true)

            return
        }

        setHostServicesLoadingProgressDialogOpen(false)
    }, [
        readHostServiceListByMonitorIdQueryIsFetching,
        readMonitorCurrentlaunchStatusQueryIsFetching,
        locationListMarketSpyHasRunning,
        manuallyCloseDialog
    ])

    const renderHelpText = () => {
        if (searchMode === 'marketSpy') {
            return `Find competitors from Market Spies`
        }

        if (searchMode === 'locationList') {
            return `Find compatitors by searching specific locations`
        }

        return ``
    }

    useEffect(() => {
        if (readHostServiceListByMonitorIdQueryData === undefined) {
            return
        }

        setSearchingResultDialogOpen(true)
    }, [
        readHostServiceListByMonitorIdQueryData
    ])

    const renderHostServices = () => {
        if (locationListMarketSpyHasRunning === true) {

            return ''
        }

        if (readHostServiceListByMonitorIdQueryIsFetching === true) {

            return ''
        }

        if (readMonitorCurrentlaunchStatusQueryIsFetching === true) {

            return ''
        }


        if (hostServicesLoadingProgressDialogOpen === true) {
            return ''
        }

        if (readHostServiceListByMonitorIdQueryData === undefined) {
            return ''
        }


        if (readHostServiceListByMonitorIdQueryIsLoading === true) {
            return ''
        }

        return (
            <div style={{maxWidth: '100vw', margin: '20px 0 0 0', borderRadius: '4px', border: '1px solid rgba(224, 224, 224, 1)' }}>
                <div>
                    <HostServiceList
                        hostServiceList={readHostServiceListByMonitorIdQueryData?.list}
                        marketSpyId={marketSpyId}
                    />
                </div>
            </div>
        )
    }

    const handleSearchModeChange = (event: any) => {
        setSearchMode(event.target.value)
    }

    const renderMainContent = () => {
        if (searchMode === 'marketSpy') {
            return (
                <div>
                    <SelectPropertySpyListFromMarketSpy
                        onMarketSpyIdChange={handleMarketSpyIdChange}
                    />
                </div>         
            )
        }

        if (searchMode === 'locationList') {
            return (
                <>
                    <div>
                        <SelectPropertySpyListFromLocation
                            onLocationListChange={handleLocationListChange}
                        />
                    </div>
                    <div>
                    <Button
                        onClick={handleSearchClick}
                        component="label"
                        color="success"
                        size="large"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<TravelExploreIcon />}
                    >
                        Search
                    </Button>
                    </div>
                </>
            )
        }

        return ``
    }

    const toggleButtonStyle = {
        'width': '140px',
        '&.Mui-selected': {
                color: '#FFF',
                backgroundColor: theme.palette.success.main,
        },
        '&.Mui-selected:hover': {
            color: '#FFF',
            backgroundColor: theme.palette.success.main,
        }
    }

    return (
        <div className={styles.PropertySpyCreateForm_Root}>
            <div className={styles.PropertySpyCreateForm_FormContainer}>
                <div className={styles.PropertySpyCreateForm_Description}>
                    {
                        renderHelpText()
                    }
                </div>

                <div className={styles.PropertySpyCreateForm_SearchModeSelectorContainer}>
                    <ToggleButtonGroup
                        color="success"
                        value={searchMode}
                        exclusive

                        onChange={handleSearchModeChange}
                        aria-label="Search mode"
               
                    >
                        <ToggleButton
                            sx={toggleButtonStyle}
                            value="marketSpy"
                        >
                            Market Spies
                        </ToggleButton>
                        <ToggleButton
                            sx={toggleButtonStyle}
                            value="locationList"
                        >
                            Locations
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                {
                    renderMainContent()
                }            
            </div>
            {
                renderHostServices()
            }   

            <HostServicesLoadingProgressDialog
                open={hostServicesLoadingProgressDialogOpen}
                onOpenChange={handleHostServicesLoadingProgressDialogOpenChange}
            />
            <SearchingResultDialog
                open={searchingResultDialogOpen}
                onOpenChange={handleSearchingResultDialogOpenChange}
                hostServiceListCount={readHostServiceListByMonitorIdQueryData?.count}
            />
        </div>
    )
}

